module.exports = __webpack_public_path__ + "static/media/youtube.e8e726af.svg";